import { render, staticRenderFns } from "./LogoSupport.vue?vue&type=template&id=49a01a05&"
import script from "./LogoSupport.vue?vue&type=script&lang=js&"
export * from "./LogoSupport.vue?vue&type=script&lang=js&"
import style0 from "./LogoSupport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports